"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var styles_module_scss_1 = __importDefault(require("../styles.module.scss"));
var react_individual_character_input_boxes_1 = __importDefault(require("react-individual-character-input-boxes"));
var ui_components_1 = require("@l2p/ui-components/");
var next_intl_1 = require("next-intl");
var Resend_1 = __importDefault(require("./Resend"));
var PhoneVerificationWithoutForm_1 = require("../../PhoneVerificationWithoutForm");
var FilledPhone_1 = __importDefault(require("./FilledPhone"));
var swr_hooks_1 = require("@l2p/swr-hooks");
var VerifyByCode = function (_a) {
    var _b, _c, _d, _e;
    var _f = _a.symbolCount, symbolCount = _f === void 0 ? 6 : _f, setNextStep = _a.setNextStep;
    var data = (0, swr_hooks_1.useUser)().data;
    var _g = (0, react_1.useState)(false), canEditPhone = _g[0], setCanEditPhone = _g[1];
    var _h = (0, react_1.useState)(''), code = _h[0], setCode = _h[1];
    var t = (0, next_intl_1.useTranslations)('phoneVerification');
    var _j = (0, react_1.useState)(false), errorDisabled = _j[0], setErrorDisabled = _j[1];
    var _k = (0, swr_hooks_1.useVerifyPhoneByCodeFromSms)({
        successAction: function () {
            setNextStep();
        },
        errorAction: function () {
            setErrorDisabled(true);
        },
    }), verifyPhoneByCodeFromSms = _k.verifyPhoneByCodeFromSms, isSubmitting = _k.isSubmitting, error = _k.error;
    var verifyPhoneHandler = (0, react_1.useCallback)(function () {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        if (((_d = (_c = (_b = (_a = data === null || data === void 0 ? void 0 : data.profile) === null || _a === void 0 ? void 0 : _a.getOne) === null || _b === void 0 ? void 0 : _b.profile) === null || _c === void 0 ? void 0 : _c.contacts) === null || _d === void 0 ? void 0 : _d.phone) && code)
            verifyPhoneByCodeFromSms({
                verifyOtpInput: {
                    phone: (_h = (_g = (_f = (_e = data === null || data === void 0 ? void 0 : data.profile) === null || _e === void 0 ? void 0 : _e.getOne) === null || _f === void 0 ? void 0 : _f.profile) === null || _g === void 0 ? void 0 : _g.contacts) === null || _h === void 0 ? void 0 : _h.phone,
                    code: code,
                },
            });
    }, [
        code,
        verifyPhoneByCodeFromSms,
        (_e = (_d = (_c = (_b = data === null || data === void 0 ? void 0 : data.profile) === null || _b === void 0 ? void 0 : _b.getOne) === null || _c === void 0 ? void 0 : _c.profile) === null || _d === void 0 ? void 0 : _d.contacts) === null || _e === void 0 ? void 0 : _e.phone,
    ]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: styles_module_scss_1.default.title }, t('verifyYourPhoneNumber')),
        canEditPhone ? (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(PhoneVerificationWithoutForm_1.PhoneVerificationWithoutForm, { closeEdited: function () {
                    setCanEditPhone(false);
                } }))) : (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("p", null, t('weSentCodeToYourNumberViaSMS')),
            react_1.default.createElement("div", { className: styles_module_scss_1.default.wrapper },
                react_1.default.createElement("span", { className: styles_module_scss_1.default.label }, t('pleaseEnterItBelow')),
                react_1.default.createElement(react_individual_character_input_boxes_1.default, { handleOutputString: function (string) {
                        setCode(string);
                        setErrorDisabled(false);
                    }, amount: symbolCount, autoFocus: false, inputRegExp: /^[0-9]$/, inputProps: {
                        className: "".concat(styles_module_scss_1.default.field, " ").concat(error ? styles_module_scss_1.default.fieldError : ''),
                        inputmode: 'numeric',
                        type: 'tel',
                        pattern: '[0-9]*',
                    } })),
            react_1.default.createElement(FilledPhone_1.default, { setCanEditPhone: function () {
                    setCanEditPhone(true);
                } }),
            react_1.default.createElement(Resend_1.default, { error: error }),
            react_1.default.createElement(ui_components_1.FixedButton, { height: "40px", width: "100%", type: "button", text: "upper", color: "gradient", loading: isSubmitting, maxWidth: "none", onClick: verifyPhoneHandler, disabled: code.length < symbolCount || errorDisabled }, t('confirm'))))));
};
exports.default = VerifyByCode;
